import React, { useCallback, useState } from "react";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import ContainerBox from "./common/containerBox.component";
import FormText from "./form/formText.component";
import { ImageListType } from "react-images-uploading";
import { Point, Area } from "react-easy-crop/types";
import getCroppedImg from "../utils/cropImage";
import { stateProps } from "../types";
import { changeSignatureImage } from "../actions";
import FormImageUploadInput from "./form/formImageUploadInput.component";
import FormWarning from "./form/formWarning.component";

const Signature: React.FC = () => {
  const dispatch = useDispatch();

  const signatureImage = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.signatureImage
  );

  const [open, setOpen] = useState(false);
  const [cropStatus, setCropStatus] = useState("Begin");
  const [croppedAreaPixels, setCroppedAreaPixels] = useState({
    height: 0,
    width: 0,
    x: 0,
    y: 0,
  });
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [images, setImages] = useState([]);

  const onCropComplete = useCallback(
    (croppedArea: Area, croppedAreaPixels: Area) => {
      console.log("Sizes", croppedArea, croppedAreaPixels);
      setCroppedAreaPixels(croppedAreaPixels);
    },
    []
  );

  const onChange = (
    imageList: ImageListType,
    addUpdateIndex: number[] | undefined
  ) => {
    console.log(imageList, addUpdateIndex);
    setImages(imageList as never[]);
    setCropStatus("Start");
    setOpen(true);
  };

  const handleClose = () => {
    showCroppedImage();
    setOpen(false);
    setCropStatus("Finish");
  };

  const showCroppedImage = useCallback(async () => {
    const { dataURL } = images[0];
    try {
      if (Object.keys(croppedAreaPixels).length !== 0) {
        const croppedImage = await getCroppedImg(dataURL, croppedAreaPixels, 0);
        dispatch(changeSignatureImage(croppedImage));
      }
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, images, dispatch]);

  return (
    <React.Fragment>
      <ContainerBox>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row", md: "row" },
          }}
        >
          <Box>
            <FormText number={"19"} title={"Upload your Signature"} />
            <FormImageUploadInput
              images={images}
              onChange={onChange}
              cropStatus={cropStatus}
              open={open}
              handleClose={handleClose}
              crop={crop}
              zoom={zoom}
              setCrop={setCrop}
              onCropComplete={onCropComplete}
              setZoom={setZoom}
              imageSrc={signatureImage}
              cropWidth={800}
              cropHeight={240}
            />
          </Box>
          <FormWarning
            title={"Your Signature"}
            subTitle={
              "Please upload a clear high-quality image of your signature."
            }
          />
        </Box>
      </ContainerBox>
    </React.Fragment>
  );
};

export default Signature;
